<template>
  <div class="modal-parent">
    <div class="gala">
      <main class="gala-container">
        <!-- BANNER -->
      <div class="gala-banner" data-v-b983b090="">
        <div class="gala-banner-content">
            <img src="../../assets/miss-mundo/images/logo.png" alt="Banner Logo" class="gala-banner-logo" data-v-b983b090="">
            <img src="../../assets/miss-mundo/images/logo_chv_blanco.png" alt="Logo CHV" class="gala-chv-logo "/>
            <h4 class="text-gold-miss mb-0">VOTA POR TU FAVORITA</h4>
            <h4 class="text-white mb-0">PARTICIPA POR $500.000</h4>
            <small class="text-white">Elige la comuna de tu candidata</small>
            <br>
            <a href="https://www.chilevision.cl/chilevision/site/docs/20251020/20251020125431/bases_chv_miss_mundo_chile.pdf" target="_blank" class="text-white" style="text-decoration: underline;">Base del concurso</a>
        </div> 
    </div>
        <!-- GRILLA -->
        <div class="gala-grid">
          <div class="gala-grid-item" v-for="(item, i) in jsonData" :key="i">
            <img srcset="" :src="item.imageLink" alt="Foto de Miss" class="img-fluid cursor-pointer" @click="sendDataForModal(item.nombre)" />
            <div class="pb-5">
                <p>{{ item.nombre.replace('Opcion', '') }}</p>
            </div>
            <div class="gala-grid-item-alias">
              <!-- <h2>{{ item.alias }}</h2> -->
              <div class="gala-grid-item-button">
                <button @click="sendDataForModal(item.nombre)">Votar</button>
              </div>
              <p>{{ item.nombre }}</p>
            </div>
          </div>
        </div>
      </main>

      <footer>
        <div>
          <p>Desarrollado por</p>
          <a href="mailto:contacto@celcom.cl" target="_blank">
            <img src="../../assets/galeria/logo_celcom_blanco.svg" alt="Logo Celcomlatam blanco"/>
          </a>
        </div>
      </footer>
      <div class="row justify-content-center">
        <div class="col-xl-8 text-center p-0">
          <div v-if="jsonData && !hayParticipantesActivos" class="got-votacion justify-content-center text-white text-uppercase">
            <h1 class="py-5 display-1">¡Votaciones Cerradas!</h1>
          </div>
          <div v-else class="gh-votacion justify-content-center text-white text-uppercase"/>
        </div>
      </div>
    </div>
    <ModalVotacionMiss
      v-if="modaIsActive"
      :dataForVotes="dataForVotes"
      :modaIsActive="modaIsActive"
      @changeModalIsActive="changeModalIsActive"
    />
    <LoaderComponent v-if="loaderIsActive"/>
  </div>
</template>

<script>
import ModalVotacionMiss from "./ModalVotacionMissMundo.vue";
import axios from "axios";
import { logout } from '@/auth.js';
import LoaderComponent from "../LoaderComponent/LoaderComponent.vue";

export default {
  name: 'MissMundoView',
  components: {
    ModalVotacionMiss,
    LoaderComponent
  },
  data() {
    return {
      jsonData: null,
      dataForVotes: {},
      modaIsActive: false,
      loaderIsActive: true,
    };
  },
  computed: {
    hayParticipantesActivos() {
      return this.jsonData.some(item => item.active);
    },
  },
  methods: {
    sendDataForModal(name){
      this.dataForVotes = {};
      this.modaIsActive = true;
      setTimeout(() => {
        const selectedItem = this.jsonData.find(item => item.nombre === name);
        this.dataForVotes = selectedItem;
      }, 10);
    },
    async cargarData() {
      await axios.get("https://automata2.celcom.cl/lp_tvi_backend/api/notification/participantes_general/lp/2")
      //axios.get("http://192.168.1.8:3113/participantes1")
        .then(response => {
          this.jsonData = response.data.filter(item => item.active && item.category === "MISS")
                .sort((a, b) => a.nombre.localeCompare(b.nombre));
        })
        .finally(() => {
          this.loaderIsActive = false;
        })
        .catch(error => {
          console.error(error);
        });
    },
    changeModalIsActive(value) {
      this.modaIsActive = value;
    },
  },
  created() {
    logout();
  },
  async mounted() {
    await this.cargarData();
    if (this.$route.params.name) {
      this.sendDataForModal(this.$route.params.name);
    }
  },
}
</script>
<style scoped lang="scss">
@font-face {
  font-family: 'avenir-regular';
  src: url('../../assets/miss-mundo/fonts/SourceSansPro-Regular.ttf');
}

@font-face {
  font-family: 'avenir-bold';
  src: url('../../assets/miss-mundo/fonts/SourceSansPro-Black.ttf');
}

.text-gold-miss {
    color: #B49B57;
}

.gala-banner-content {
    text-align: center;
    padding: 40px 0;
}
.gala-banner-logo {
    position: initial;
    width: 250px;
}
.text-green-miss {
    color: #0DB7B2;
}
@media (max-width:768px) {
    .gala-banner {
        height: initial;
    }
}
.gala{
  background-image: url('../../assets/miss-mundo/images/background.jpg');
  background-position: center;
  background-size: cover;
  font-family: 'avenir-regular';
  min-height: 100vh;
  padding-bottom: 250px;
  position: relative;

  p{
    margin: 0;
  }

  a{
    text-decoration: none;
    color: inherit;
  }

  &-banner{
    position: relative;

    &-logo{
      top: 50%;
      left: 50%;
      width: 250px;
    }

    &-text{
      background-color: #000;
      color: #FFF;
      text-align: center;
      padding: 8px 16px;
      font-size: 14px; 
    }
  }

  footer{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #000;
    color: #FFF;
    padding: 8px 0;
    font-size: 14px;
    text-align: center;

    a{
      text-decoration: underline;
    }

    div{
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;

      a{
        text-decoration: none;
        
        img{
          margin-top: -4px;
          width: 70px;
        }
      } 
    }
  }
}
@media (max-width:768px) {
    .gala-banner {
        height: initial;
    }
    .gala{
      background-image: url("../../assets/miss-mundo/images/back_mobile.jpg");
    }
}
.gala-container {
  width: 100%;
  margin: 0 auto;

  // Tamaño por defecto (Mobile)
  max-width: 480px;

  // Tablet
  @media (min-width: 481px) {
    max-width: 640px;
  }

  // Desktop
  @media (min-width: 1024px) {
    max-width: 960px;
  }
}

.gala-grid {
  padding: 16px;
  display: grid;
  gap: 16px; 

  grid-template-columns: repeat(2, 1fr);

  @media (min-width: 481px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(5, 1fr);
  }

  &-item{
    position: relative;
    padding: 8px;
    background-image: linear-gradient(45deg, #2c2b5e, #111138);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    
    p{
      font-size: 14px;
      color: #FFF;
    }

    &-number{
      position: absolute;
      top: 60%;
      right: -20px;
      transform: translateY(-50%);
      width: 80px;
      height: 80px;
      border: 10px solid rgba(90, 47, 126, 0.1);
      border-radius: 50%;
      z-index: 0;  

      p{
        font-family: 'avenir-bold';
      color: rgba(90, 47, 126, 0.1);
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 24px;
      }
    }

    &-alias{
      text-align: center;
      width: 100%;

      h2{
        font-size: 16px;
        font-family: 'avenir-bold';
        color: #FFF;
        margin-bottom: 12px;
      }
      
      p{
        margin-bottom: 4px;
        font-size: 12px;
        color: #FFF;
      }
    }

    &-button{
      position: relative;
      margin-top: 4px;
      text-align: center;
      
      button{
        outline: none;
        border: none;
        border-radius: 12px;
        background: linear-gradient(45deg, #ff9800, #ff5722); /* Tonos cálidos del logo */
        font-size: 14px;
        font-weight: bold;
        color: #FFF;
        padding: 6px 16px;
        letter-spacing: 0.5px;
        width: 100%;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        box-shadow: 0 4px 12px rgba(255, 152, 0, 0.4); /* Resaltado */
        margin-bottom: 8px;
      }
    }
  }
}
.gala-grid-item-button button {
    outline: none;
    border: none;
    border-radius: 12px;
    background: linear-gradient(45deg, #E8D7EC, #6577BA);
    font-size: 14px;
    font-weight: 700;
    color: #131E29;
    padding: 6px 16px;
    letter-spacing: .5px;
    width: 100%;
    cursor: pointer;
    transition: all .3s ease-in-out;
    box-shadow: 0 4px 12px #E8D7EC66;
    margin-bottom: 8px;
}

.gala-grid-item-alias {
    text-align: center;
    width: 100%;
    padding: 5px 10px;
    position: absolute;
    bottom: 0;
    background-image: linear-gradient(45deg, #2c2b5e, #111138);
}
.gala-grid-item {
    position: relative;
    padding: 0px;
    background-image: linear-gradient(45deg, #2c2b5e, #111138);
    box-shadow: 0 4px 12px rgba(0, 0, 0, .3);
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    justify-content: center;
}
.modal-parent{
  overflow: hidden;
}
.gala-grid-item .gala-grid-item-alias {
    background-image: linear-gradient(45deg,#061733,#1d1d77);
}

.gala-grid-item .gala-grid-item-button button {
    background: linear-gradient(45deg,#002773 ,#009ffc);
    color: #bebebf;
    box-shadow: 0 4px 12px #bebebf66;
}
.gala-chv-logo {
    display: block;
    margin: 0 auto;
    padding: 30px;
    width: 250px;
}
</style>
